<template>
  <div class="phone-lines">
    <img src="@/assets/images/agents-circle.png" alt="Internet speed illustration">
  </div>
</template>

<script>
export default {
  name: 'PhoneLinesIcon'
}
</script>

<style scoped lang="scss">
.phone-lines > img {
  width: $agents-icon-size;
  height: $agents-icon-size;
}
</style>
